import React from 'react';
import { FiInfo } from 'react-icons/fi';
//css
import './ErrorMsg.css';

export default function ErrorMsg({ errorMsg }) {
    return (
        <>
            <span className="error-msg-container">
                <FiInfo style={{ stroke: "#E45D5D" }} size="15px" />
                <span className='error-msg'><p>{errorMsg}</p></span>
            </span>
        </>
    );
}